import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from "../../_models/user";
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-shipyaari-manage',
  templateUrl: './shipyaari-manage.component.html',
  styleUrls: ['./shipyaari-manage.component.scss'],
})
export class ShipyaariManageComponent implements OnInit {

  carrierNameError: string;
  avnKeyError: string;
  carrierId: string;
  shipyaariData: any = {};

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.getCarrierInfoById(this.user.accountOwnerId, this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.shipyaariData = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.shipyaariData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  avnKeyBlur() {
    this.avnKeyError = "";
    if (!this.shipyaariData.avnKey) {
      this.avnKeyError = 'Please enter avnKey';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.avnKeyError = "";

    if (!this.shipyaariData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.shipyaariData.avnKey) {
      this.avnKeyError = 'Please enter avnKey';
    }
    if (this.carrierNameError != "" || this.avnKeyError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {
      "connectionName": this.shipyaariData.connectionName,
      "carrierCode": this.shipyaariData.carrierCode,
      "organizationId": this.shipyaariData.organizationId,
      "avnKey": this.shipyaariData.avnKey,
      "carrierId": this.shipyaariData.carrierId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shipyaari', 'Create Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}

